import { Phone, Clock, ShieldCheck, MapPin } from "@phosphor-icons/react";
import { Reveal } from "@/components/site/Reveal";
import { PHONE_DISPLAY, PHONE_TEL, IMAGES } from "@/lib/brand";

export const SiteFooter = () => (
  <footer data-testid="site-footer" className="relative z-10 bg-[var(--tt-black)]">
    {/* Final CTA band */}
    <Reveal>
      <div className="mx-auto max-w-[1400px] px-5 md:px-10 lg:px-16 py-24 md:py-32 border-b border-white/10 text-center">
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[var(--tt-green)] mb-6">
          When the Road Turns Against You
        </p>
        <h2 className="font-display uppercase text-5xl md:text-7xl lg:text-8xl tracking-tighter leading-[0.85] mb-10">
          Stranded? <br />
          <span className="text-[var(--tt-green)] tt-text-glow">Call the owner.</span>
        </h2>
        <a
          href={PHONE_TEL}
          data-testid="footer-cta-button"
          className="group inline-flex items-center gap-3 bg-[var(--tt-green)] text-black font-display uppercase text-xl md:text-2xl px-10 py-5 border-2 border-[var(--tt-green)] hover:bg-transparent hover:text-[var(--tt-green)] hover:shadow-[0_0_34px_rgba(57,255,20,0.5)] transition-[background-color,color,box-shadow] duration-300 tt-clip-card"
        >
          <Phone weight="fill" className="h-6 w-6 group-hover:rotate-12 transition-transform" />
          Call Now: {PHONE_DISPLAY}
        </a>
      </div>
    </Reveal>

    {/* Footer info */}
    <div className="mx-auto max-w-[1400px] px-5 md:px-10 lg:px-16 py-14">
      <div className="grid grid-cols-1 md:grid-cols-[1.4fr_1fr_1fr] gap-10 md:gap-8 mb-14">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src={IMAGES.logo} alt="Twizted Tow" className="h-12 w-auto" />
            <span className="font-display text-xl uppercase tracking-tight">
              Twizted<span className="text-[var(--tt-green)]">Tow</span>
            </span>
          </div>
          <p className="text-zinc-500 text-sm leading-relaxed max-w-xs">
            Owner-operated flatbed towing & recovery serving Rock Hill, South Carolina and the
            surrounding York County area.
          </p>
          <div className="flex items-center gap-2 mt-5 text-zinc-400 text-sm">
            <MapPin weight="fill" className="h-4 w-4 text-[var(--tt-green)]" />
            Rock Hill, SC · York County
          </div>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">Contact</h4>
          <a
            href={PHONE_TEL}
            data-testid="footer-call-link"
            className="flex items-center gap-2 font-display uppercase text-2xl md:text-3xl text-white hover:text-[var(--tt-green)] transition-colors"
          >
            <Phone weight="fill" className="h-6 w-6" />
            {PHONE_DISPLAY}
          </a>
          <p className="text-zinc-500 text-sm mt-3">Direct line to the owner — no dispatch queue.</p>
        </div>

        <div>
          <h4 className="font-mono text-xs uppercase tracking-[0.2em] text-zinc-500 mb-5">Hours</h4>
          <div className="flex items-start gap-2 text-zinc-300">
            <Clock weight="fill" className="h-5 w-5 text-[var(--tt-green)] mt-0.5" />
            <div>
              <p className="font-semibold text-white">8:00 AM – 6:00 PM</p>
              <p className="text-zinc-500 text-sm mt-1">Monday – Saturday</p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex items-start gap-2 text-zinc-500 text-xs leading-relaxed border-t border-white/10 pt-6 mb-6">
        <ShieldCheck weight="fill" className="h-4 w-4 text-[var(--tt-green)] shrink-0 mt-0.5" />
        Fully licensed &amp; insured for private and commercial towing in the state of South
        Carolina. Coverage carried on every load, every mile.
      </div>

      <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-zinc-600 text-xs font-mono uppercase tracking-wider">
        <span>© {new Date().getFullYear()} Twizted Tow. All rights reserved.</span>
        <span>Rock Hill, South Carolina</span>
      </div>
    </div>
  </footer>
);
